<template>
  <v-slider
    :color="item.color || undefined"
    :label="item.label || undefined"
    :min="item.min || 0"
    :max="item.max || 100"
    :thumb-label="item.thumbLabel || false"
    v-model="item.value"
    :append-icon="item.appendIcon || undefined"
    :prepend-icon="item.prependIcon || undefined"
    :step="item.step || 1"
  ></v-slider>
</template>

<script>

'use strict'

export default {

  name: 'VuetifySlider',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    item: {
      type: Object,
      default: null,
      required: true
    },
    value: {
      type: String,
      default: null
    }
  },

  watch: {
    'item.value': function (newVal, oldVal) {
      this.$emit('on-change', newVal, oldVal, this.item)
    }
  },

  methods: {
    focusNextField: function (event) { }
  }
}
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-slider.vue